import useCountUp from "../hooks/useCountUp";

const STATS = [
  { target: 15, suffix: "+", label: "Export Countries" },
  { target: 600, suffix: "+", label: "Total SKUs" },
  { target: 100, suffix: "%", label: "QC Inspected" },
  { target: 6, suffix: "", label: "Product Categories" },
];

function StatCard({ target, suffix, label }) {
  const [ref, display] = useCountUp(target, { suffix, duration: 1800 });

  return (
    <div
      ref={ref}
      className="bg-bg rounded-2xl border border-border p-6 md:p-8 text-center"
    >
      <div className="font-serif text-4xl md:text-5xl font-bold text-primary">{display}</div>
      <div className="mt-2 label-cap text-muted">{label}</div>
    </div>
  );
}

export default function StatsRow() {
  return (
    <section className="py-8 md:py-10 bg-surface-alt/60 border-y border-border">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6">
          {STATS.map((s) => (
            <StatCard key={s.label} {...s} />
          ))}
        </div>
      </div>
    </section>
  );
}
